import { Link, SxProps, Theme, Typography } from '@mui/material'

type RecaptchaNoticeProps = {
	sx?: SxProps<Theme>
}

// Google requires this attribution on forms that use reCAPTCHA when the badge is hidden
const RecaptchaNotice: React.FC<RecaptchaNoticeProps> = ({ sx }) => (
	<Typography color="textSecondary" variant="caption" component="p" sx={sx}>
		This site is protected by reCAPTCHA and the Google{' '}
		<Link
			href="https://policies.google.com/privacy"
			target="_blank"
			rel="noopener noreferrer"
			color="inherit"
		>
			Privacy Policy
		</Link>{' '}
		and{' '}
		<Link
			href="https://policies.google.com/terms"
			target="_blank"
			rel="noopener noreferrer"
			color="inherit"
		>
			Terms of Service
		</Link>{' '}
		apply.
	</Typography>
)

export default RecaptchaNotice
